<div class="legal-page">
  <!-- Page Header -->
  <section class="page-header">
    <div class="container">
      <h1 class="page-title">Impressum</h1>
      <p class="page-subtitle">Rechtliche Informationen</p>
    </div>
  </section>

  <!-- Legal Content -->
  <section class="legal-content section">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 mx-auto">
          <div class="legal-card">
            
            <!-- Company Information -->
            <div class="legal-section">
              <h3>Angaben gemäß § 5 TMG</h3>
              <div class="info-block">
                <strong>Mitra Sanitär GmbH</strong><br>
                Borussiastraße 62a<br>
                12103 Berlin<br>
                Deutschland
              </div>
            </div>

            <!-- Management -->
            <div class="legal-section">
              <h4>Vertreten durch:</h4>
              <div class="info-block">
                Geschäftsführer: Patrick van Dalen
              </div>
            </div>

            <!-- Contact -->
            <div class="legal-section">
              <h4>Kontakt:</h4>
              <div class="info-block">
                <strong>Telefon:</strong> 030 76008921<br>
                <strong>E-Mail:</strong> hey&#64;mitra-sanitaer.de<br>
                <strong>Website:</strong> www.mitra-sanitaer.de
              </div>
            </div>

            <!-- Registration -->
            <div class="legal-section">
              <h4>Registereintrag:</h4>
              <div class="info-block">
                Eintragung im Handelsregister<br>
                <strong>Registergericht:</strong> Amtsgericht Charlottenburg <br>
                <strong>Registernummer:</strong> HRB 267802 B
              </div>
            </div>

            <!-- Tax ID -->
            <div class="legal-section">
              <h4>Umsatzsteuer-ID:</h4>
              <div class="info-block">
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br>
                <strong>DE370050121</strong>
              </div>
            </div>

            <!-- Professional Information -->
            <div class="legal-section">
              <h4>Berufsbezeichnung und berufsrechtliche Regelungen:</h4>
              <div class="info-block">
                <strong>Berufsbezeichnung:</strong> Installateur- und Heizungsbauermeister<br>
                <strong>Zuständige Kammer:</strong> Handwerkskammer Berlin<br>
                <strong>Verliehen durch:</strong> Deutschland
              </div>
            </div>

            <!-- Liability -->
            <div class="legal-section">
              <h4>Haftung für Inhalte</h4>
              <div class="info-block">
                <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
                <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
              </div>
            </div>

            <!-- Links -->
            <div class="legal-section">
              <h4>Haftung für Links</h4>
              <div class="info-block">
                <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
                <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
              </div>
            </div>

            <!-- Copyright -->
            <div class="legal-section">
              <h4>Urheberrecht</h4>
              <div class="info-block">
                <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
                <p>Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
              </div>
            </div>

            <!-- Privacy -->
            <div class="legal-section">
              <h4>Datenschutz</h4>
              <div class="info-block">
                <p>Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.</p>
                <p>Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.</p>
              </div>
            </div>

            <!-- Dispute Resolution -->
            <div class="legal-section">
              <h4>Streitschlichtung</h4>
              <div class="info-block">
                <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a></p>
                <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</div>